import { DateTime } from "luxon";

import { offsetAt } from "./tzrules";

// ============================================================
//  Zone fills — the land of every time zone, cut to the coast.
//
//  public/data/zone-fills.json (scripts/build-zones.mjs) holds the
//  timezone-boundary-builder "with-oceans-now" zones intersected with
//  Natural Earth 1:50m land: per zone, the polygons (outer ring, then
//  holes; flat [lng, lat, …], unwrapped past ±180°) of its land. The
//  land mesh (landmesh.ts) triangulates them and colours each zone by
//  its live UTC offset. Antarctica keeps no one time and comes as ice
//  (tz null).
// ============================================================

const DATA_URL = "/data/zone-fills.json";

export interface ZoneFill {
  tz: string | null;
  polygons: number[][][];
}

export async function loadZoneFills(): Promise<ZoneFill[]> {
  const res = await fetch(DATA_URL);
  if (!res.ok) throw new Error(`zone-fills: ${res.status}`);
  return ((await res.json()) as { zones: ZoneFill[] }).zones;
}

/** Live offset of each zone in minutes; null for ice. */
export function liveOffsets(zones: ZoneFill[], now: DateTime): (number | null)[] {
  const ms = now.toMillis();
  return zones.map((z) => (z.tz ? offsetAt(z.tz, ms) : null));
}
